export const FEATURE_FLAG_EXPERIMENT_COOKIE_NAME = 'x-flag-exp'
export const FEATURE_FLAG_INTERNAL_COOKIE_NAME = 'x-flag-internal'

export const flags = {
  FLAG_FEAT_MERGE_CCMS_M360_INVOICE_REQS: 'merge-ccms-m360-invoice-reqs',
  FLAG_FEAT_UNIFIED_INVOICES: 'membership-unified-invoices',
  FLAG_FEAT_ANNUAL_SURVEY: 'membership-annual-survey-link',
  FLAG_FEAT_MEMBERSHIP_JOURNEY_DASHBOARD: 'membership-journey-dashboard',
  FLAG_FEAT_MEMBERSHIP_JOURNEY_LEVEL1_UAT: 'membership-journey-level1-uat',
  FLAG_SALESFORCE_MIGRATION_STATUS: 'backoffice-salesforce-migration'
}
